import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './containers/App/store';
import App from './containers/App/App';

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
